export const SAVED_GAME_KEY = "revelate_saved_game_v1";
export const SAVED_GAME_VERSION = 1;

function isTile(value) {
  return value === null || (typeof value === "string" && value.length > 0);
}

export function isValidSavedGame(snapshot) {
  if (!snapshot || snapshot.version !== SAVED_GAME_VERSION || snapshot.paused !== true) return false;
  if (!Array.isArray(snapshot.grid) || snapshot.grid.length !== 11) return false;
  if (!snapshot.grid.every((row) => Array.isArray(row) && row.length === 8 && row.every(isTile))) return false;
  if (!snapshot.block || !Number.isInteger(snapshot.block.row) || !Number.isInteger(snapshot.block.col) || typeof snapshot.block.letter !== "string") return false;
  if (snapshot.block.row < 0 || snapshot.block.row >= 11 || snapshot.block.col < 0 || snapshot.block.col >= 8) return false;
  return ["score", "level", "longWords", "spawnCount", "lastLongWordMilestone"].every(
    (field) => typeof snapshot[field] === "number" && Number.isFinite(snapshot[field])
  ) && typeof snapshot.nextLetter === "string" && !snapshot.gameOver && !snapshot.clearing;
}

export function readPersistentSavedGame(storage = window.localStorage) {
  try {
    const parsed = JSON.parse(storage.getItem(SAVED_GAME_KEY));
    return isValidSavedGame(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writePersistentSavedGame(snapshot, storage = window.localStorage) {
  const saved = { ...snapshot, version: SAVED_GAME_VERSION, paused: true, savedAt: Date.now() };
  if (!isValidSavedGame(saved)) return false;
  try {
    storage.setItem(SAVED_GAME_KEY, JSON.stringify(saved));
    return true;
  } catch {
    return false;
  }
}

export function chooseContinueGame(liveGame, persistentGame) {
  return liveGame || persistentGame || null;
}
